var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.data.values),function(param){return _c('v-row',{key:param.title,staticClass:"mt-0 mb-0"},[_c('v-col',{staticClass:"col-12 col-sm-6"},[_vm._v(" "+_vm._s(_vm.getParamTitle(param.parameterId))+" ")]),_c('v-col',{staticClass:"col-12 col-sm-6 promotions-info__value"},[_vm._v(" "+_vm._s(param.value)+" ")])],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }